<template>
    <section class="h-full d-flex flex-column">
        <TopAppBar
            :leftBtnMode="leftBtnMode"
            :rightBtnMode="rightBtnMode"
            :title="title"
            :leftBtnMethod="leftBtnMethod"
            :rightBtnMethod="rightBtnMethod"
            staticMode="true"
        >
        </TopAppBar>
        <div class="bg-white flex-grow-1 scroll-y">
            <div class="pda-default">
                <div class="t-headline5">
                    {{$t('364')}}
                    <!-- 비밀번호 재설정 -->
                </div>
                <router-view></router-view>
            </div>
        </div>
    </section>
  
</template>

<script>
/**
 * 비밀번호 찾기 메인 컴포넌트(find password main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '../mixins/topAppBar.js'

export default {
    name: 'findpw',
    data() {
        return {
            
        }
    },
    components: {
        TopAppBar
    },

    watch: {
        '$route' (to, from) {
            if (to.name === 'FindPwStep1') {
                this.setTopAppBarCloseOnly('')
            }else {
                this.setTopAppBarBackOnly('')
            }
        }
    },

    mixins: [topAppBarMixin],

    mounted() {
        this.setTopAppBarCloseOnly('')
    },
    methods: {
        setTopAppBarBackOnly(title) {
            this.leftBtnMode = 'arrow_back'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },

        setTopAppBarCloseOnly(title) {
            this.leftBtnMode = 'close'
            this.rightBtnMode = ''
            this.title = title || this.title
            this.leftBtnMethod = () => {
                this.$router.go(-1)
            }
            this.rightBtnMethod = ''
        },
    }
}
</script>